<template>
    <div class="Order">
        <div class="table-container">
            <el-table 
                :data="tableData" 
                border
                class="no-wrap-table"
                :show-overflow-tooltip="false">
                <el-table-column type="selection" align="center" width="55" />
                <!-- <el-table-column cell-class-name="custom-text-size" prop="id" label="ID" min-width="80"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="userName" label="姓名" min-width="100"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="userPhone" label="电话" min-width="120"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="userUnitLevel" label="单位等级" min-width="120"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="userZhicheng" label="职称" min-width="120"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="userEmail" label="邮箱" min-width="180"></el-table-column> -->
                <el-table-column cell-class-name="custom-text-size" prop="projectCode" label="项目编号" min-width="120"></el-table-column>
                <el-table-column 
                    cell-class-name="custom-text-size ellipsis-cell" 
                    prop="projectCase" 
                    label="项目主题" 
                    min-width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.projectCase }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="custom-text-size ellipsis-cell" 
                    prop="worksType" 
                    label="内容形式" 
                    min-width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.worksType }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="custom-text-size ellipsis-cell" 
                    prop="worksName" 
                    label="作品名称" 
                    min-width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.worksName }}</div>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="statusText" label="状态" min-width="100">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)">
                            {{ scope.row.statusText }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="expertScore" label="专家评分" min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.expertScore || '-' }}
                    </template>
                </el-table-column>
                <!-- <el-table-column cell-class-name="custom-text-size" prop="des" label="备注" min-width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.des || '-' }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column cell-class-name="custom-text-size" label="操作" fixed="right" width="140">
                    <template slot-scope="scope">
                        <div class="operation-buttons">
                            <el-button 
                                class="ColorBlue" 
                                size="mini" 
                                @click="Number(scope.row.status) === 0 ? handleEdit(scope.row) : handleView(scope.row)">
                                {{ Number(scope.row.status) === 0 ? '编辑' : '详情' }}
                            </el-button>
                            <el-button 
                                v-if="Number(scope.row.status) === 3"
                                class="ColorBlue" 
                                size="mini" 
                                @click="handleEdit(scope.row)">
                                修改
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="PageDis">
            <el-pagination 
                background 
                :page-sizes="[10, 20, 50]" 
                layout="prev,pager,next,total,sizes"  
                @size-change="SizeChange" 
                @current-change="PageChange" 
                :total="total" 
                :current-page="page" 
                :hide-on-single-page="false">
            </el-pagination>
        </div>
        <el-dialog title="作品详情" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
            <div class="detail-content">
                <div class="section-title">基本信息</div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <span class="label">姓名：</span>
                        <span class="value">{{viewForm.userName}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">所属项目：</span>
                        <span class="value">{{viewForm.projectCode}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">电话：</span>
                        <span class="value">{{viewForm.userPhone}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">邮箱：</span>
                        <span class="value">{{viewForm.userEmail}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">单位：</span>
                        <span class="value">{{viewForm.userUnit}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">职位：</span>
                        <span class="value">{{viewForm.userZhicheng}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">科室：</span>
                        <span class="value">{{viewForm.userDept || ''}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">职称：</span>
                        <span class="value">{{viewForm.userZhicheng}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">单位等级：</span>
                        <span class="value">{{viewForm.userUnitLevel}}</span>
                    </div>
                </div>

                <div class="section-divider"></div>
                
                <div class="section-title">专业信息</div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <span class="label">项目编号：</span>
                        <span class="value">{{viewForm.projectCode}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">作品名称：</span>
                        <span class="value">{{viewForm.worksName}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">项目主题：</span>
                        <span class="value">{{viewForm.projectCase}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">创作时间：</span>
                        <span class="value">{{viewForm.workTime || ''}}</span>
                    </div>
                    <!-- <div class="detail-item">
                        <span class="label">作品成绩：</span>
                        <span class="value">{{viewForm.isGood === 1 ? '优秀' : '一般'}}</span>
                    </div> -->
                    <div class="detail-item">
                        <span class="label">内容形式：</span>
                        <span class="value">{{viewForm.worksType}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">作品状态：</span>
                        <span class="value">{{viewForm.statusText}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">备注：</span>
                        <span class="value">{{viewForm.des || '-'}}</span>
                    </div>
                    
                    <!-- 根据内容形式显示相应的文件 -->
                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普文章') || viewForm.rawWorksType === '1')" class="detail-item">
                        <span class="label">科普文章：</span>
                        <div class="file-item">
                            <img src="../../assets/applyRey/word.png" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普文章')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普文章')">下载</el-button>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普图画') || viewForm.rawWorksType === '2')" class="detail-item">
                        <span class="label">科普图画：</span>
                        <div class="file-item">
                            <!-- <img src="../../assets/applyRey/mp4.jpg" class="file-icon" /> -->
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普图画')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普图画')">下载</el-button>
                            </div>
                        </div>
                    </div>

                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普短视频') || viewForm.rawWorksType === '3')" class="detail-item">
                        <span class="label">科普短视频：</span>
                        <div class="file-item">
                            <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普短视频')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普短视频')">下载</el-button>
                            </div>
                        </div>
                    </div>

                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普讲座') || viewForm.rawWorksType === '4')" class="detail-item">
                        <span class="label">科普讲座：</span>
                        <div class="file-item">
                            <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普讲座')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普讲座')">下载</el-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-divider"></div>
                
                <div class="section-title">作品授权书</div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <div class="file-item">
                            <img src="../../assets/applyRey/pdf.png" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('授权书')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('授权书')">下载</el-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-divider"></div>
                
                <div class="detail-grid" style="grid-template-columns: repeat(2, 1fr); gap: 20px;">
                    <div v-if="Number(viewForm.status) === 1 || Number(viewForm.status) === 2">
                        <div class="section-title">作品收录证书</div>
                        <div class="detail-item">
                            <div class="file-item">
                                <img src="../../assets/applyRey/pdf.png" class="file-icon" />
                                <div class="file-actions">
                                    <el-button type="text" class="action-btn" @click="viewFile('证书')">查看</el-button>
                                    <!-- <el-button type="text" class="action-btn" @click="downloadFile('证书')">下载</el-button> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="Number(viewForm.isGood) === 1 && Number(viewForm.isGoodword) === 1">
                        <div class="section-title">优秀作品证书</div>
                        <div class="detail-item">
                            <div class="file-item">
                                <img src="../../assets/applyRey/pdf.png" class="file-icon" />
                                <div class="file-actions">
                                    <el-button type="text" class="action-btn" @click="viewFile('优秀证书')">查看</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-divider"></div>
                
                <div class="section-title">审核评语</div>
                <div class="detail-grid">
                    <div class="detail-item" v-for="(check, index) in viewForm.checkList" :key="index">
                        <span class="label">{{ check.level === 1 ? '合规审核' : check.level === 2 ? '学术初审' : check.level === 3 ? '专家复评' : check.level === 4 ? '合规审核' : '审核人'+check.level }}：</span>
                        <span class="value">{{check.msg || '-'}}</span>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 修改视频播放弹窗 -->
        <el-dialog
            :title="videoTitle"
            :visible.sync="videoDialogVisible"
            :width="isMobile ? '95%' : '800px'"
            :close-on-click-modal="false"
            :fullscreen="isMobile"
            class="video-dialog"
            @close="closeVideoDialog">
            <div class="video-container">
                <video
                    ref="videoPlayer"
                    class="video-player"
                    controls
                    :src="currentVideoUrl"
                    controlsList="nodownload"
                    preload="auto"
                    playsinline
                    webkit-playsinline
                    x5-video-player-type="h5"
                    x5-video-player-fullscreen="true"
                    x5-video-orientation="portraint">
                    您的浏览器不支持 HTML5 视频播放
                </video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { checkTokenExpiration, clearLoginInfo } from '@/utils/auth'

    export default {
        data() {
            return {
                i:1,
                tableData:[],
                total:0,
                page:1,
                SizePage:10,
                dialogVisible: false,
                viewForm: {
                    id: '',
                    userName: '',
                    userPhone: '',
                    userUnitLevel: '',
                    userZhicheng: '',
                    userEmail: '',
                    projectCode: '',
                    projectCase: '',
                    worksType: '',
                    worksName: '',
                    status: '',
                    statusText: '',
                    des: ''
                },
                videoDialogVisible: false,
                currentVideoUrl: '',
                videoTitle: '',
                isMobile: false,
            }
        },
        created() {
            this.getWorksList();
            // 检测是否为移动设备
            this.checkIsMobile();
            // 监听窗口大小变化
            window.addEventListener('resize', this.checkIsMobile);
        },
        beforeDestroy() {
            // 移除事件监听
            window.removeEventListener('resize', this.checkIsMobile);
        },
        methods: {
            ToggleNav(i){
                this.i = i;
            },
            LockInfo(row){
                
            },
            SizeChange(val) {
                this.SizePage = val;
                this.page = 1;
                this.getWorksList();
            },
            PageChange(val) {
                this.page = val;
                this.getWorksList();
            },
            getWorksTypeText(types) {
                const typeMap = {
                    '1': '科普文章',
                    '2': '科普图画',
                    '3': '科普短视频',
                    '4': '科普讲座'
                };
                
                const typeArray = types.split(',');
                
                return typeArray.map(type => typeMap[type.trim()] || type).join('，');
            },
            getWorksList() {
                // 检查token是否有效
                const status = checkTokenExpiration();
                if (status.expired) {
                    clearLoginInfo(); // 清除登录信息
                    this.$confirm(status.message, '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true,
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.$router.push('/');
                    }).catch(() => {
                        this.$router.push('/');
                    });
                    return;
                }

                const params = {
                    pageNum: this.page,
                    pageSize: this.SizePage
                };
                
                this.$get('/api/v1/works/workslistExclude38', params).then(res => {
                    if (res.data.code === 200) {
                        this.tableData = res.data.rows.map(item => {
                            // Find the expert score (level 3) from checkList
                            const expertCheck = item.checkList ? item.checkList.find(check => check.level === 3) : null;
                            const expertScore = expertCheck ? expertCheck.score : null;

                            return {
                                id: item.id,
                                userName: item.userName,
                                userPhone: item.userPhone,
                                userUnitLevel: item.userUnitLevel,
                                userZhicheng: item.userZhicheng,
                                userEmail: item.userEmail,
                                projectCode: item.projectCode,
                                projectCase: item.projectCase,
                                worksType: this.getWorksTypeText(item.worksType),
                                worksName: item.worksName,
                                status: item.status,
                                statusText: this.getStatusText(item.status),
                                des: item.des || '',
                                expertScore: expertScore
                            };
                        });
                        this.total = res.data.total || 0;
                    } else {
                        this.$message.error(res.data.msg || '获取列表失败');
                    }
                }).catch(err => {
                    console.error('获取作品列表失败:', err);
                    this.$message.error('获取列表失败');
                });
            },
            getStatusText(status) {
                const statusMap = {
                    0: '待合规审核',
                    1: '待专家复评',
                    2: '完成',
                    3: '审核不通过',
                    4: '待学术初审',
                    5: '已付款',
                    6: '审核中'
                };
                return statusMap[status] || status;
            },
            handleEdit(row) {
                // 先获取作品详情
                this.$get(`/api/v1/works/workinfo/${row.id}`).then(res => {
                    if (res.data.code === 200) {
                        // 将作品详情存储到 localStorage
                        localStorage.setItem('editWorksInfo', JSON.stringify(res.data.data));
                        localStorage.setItem('isEdit', 'true');  // 添加编辑标识
                        // 跳转到 ApplyReg 路由
                        this.$router.push({
                            path: '/ApplyReg',
                            query: {
                                type: 1,
                                isEdit: 'true',
                                worksId: row.id
                            }
                        });
                    } else {
                        this.$message.error(res.data.msg || '获取作品详情失败');
                    }
                }).catch(err => {
                    console.error('获取作品详情失败:', err);
                    this.$message.error('获取作品详情失败');
                });
            },
            handleDelete(row) {
                this.$confirm('确认删除该作品?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message.success('删除成功');
                    this.getWorksList();
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
            },
            handleView(row) {
                this.$get(`/api/v1/works/workinfo/${row.id}`).then(res => {
                    if (res.data.code === 200) {
                        // 获取完整的作品详情后显示
                        const detail = res.data.data;
                        // 保存原始的worksType值用于条件判断
                        const rawWorksType = detail.worksType;
                        // 转换worksType为文本描述
                        detail.worksType = this.getWorksTypeText(detail.worksType);
                        this.viewForm = {
                            ...row,
                            ...detail,
                            rawWorksType, // 保存原始值
                            des: detail.des || '',
                            workCertFile: detail.certificateFile || '', // 添加证书文件字段
                            isGood: detail.isGood || 0,
                            isGoodword: detail.isGoodword || 0,
                            goodwordFile: detail.goodwordFile || '' // 添加优秀作品证书文件字段
                        };
                        this.dialogVisible = true;
                    } else {
                        this.$message.error(res.data.msg || '获取作品详情失败');
                    }
                }).catch(err => {
                    console.error('获取作品详情失败:', err);
                    this.$message.error('获取作品详情失败');
                });
            },
            getStatusType(status) {
                const typeMap = {
                    '0': 'info',
                    '1': 'warning',
                    '2': 'success',
                    '3': 'danger',
                    '4': 'success',
                    '5': 'success',
                    '6': 'info'
                };
                return typeMap[status] || '';
            },
            viewFile(fileType) {
                let filePath = '';
                let tipMessage = '';
                
                switch(fileType) {
                    case '科普文章':
                        filePath = this.viewForm.workFile;
                        tipMessage = '暂无科普文章文件';
                        break;
                    case '科普图画':
                        filePath = this.viewForm.workPicFile;
                        tipMessage = '暂无科普图画文件';
                        break;
                    case '科普短视频':
                    case '科普讲座':
                        // 对于视频文件，使用新的播放方式
                        filePath = fileType === '科普短视频' ? 
                            this.viewForm.workVedioFile : 
                            this.viewForm.workJzFile;
                        tipMessage = `暂无${fileType}文件`;
                        if (filePath) {
                            this.playVideo(filePath, fileType);
                            return;
                        }
                        break;
                    case '授权书':
                        filePath = this.viewForm.workAuthFile;
                        tipMessage = '暂无作品授权书文件';
                        break;
                    case '证书':
                        filePath = this.viewForm.workCertFile;
                        tipMessage = '暂无作品收录证书文件';
                        break;
                    case '优秀证书':
                        filePath = this.viewForm.goodwordFile;
                        tipMessage = '暂无优秀作品证书文件';
                        break;
                    default:
                        filePath = '';
                        tipMessage = '暂无文件';
                }
                
                if (filePath) {
                    window.open(filePath, '_blank');
                } else {
                    this.$message({
                        message: tipMessage,
                        type: 'warning'
                    });
                }
            },
            async downloadFile(fileType) {
                let filePath = '';
                
                switch(fileType) {
                    case '科普文章':
                        filePath = this.viewForm.workFile;
                        break;
                    case '科普图画':
                        filePath = this.viewForm.workPicFile;
                        break;
                    case '科普短视频':
                        filePath = this.viewForm.workVedioFile;
                        break;
                    case '科普讲座':
                        filePath = this.viewForm.workJzFile;
                        break;
                    case '授权书':
                        filePath = this.viewForm.workAuthFile;
                        break;
                    case '证书':
                        filePath = this.viewForm.workCertFile;
                        break;
                    default:
                        filePath = '';
                }
                
                if (filePath) {
                    try {
                        // 显示加载提示
                        const loading = this.$loading({
                            lock: true,
                            text: '正在下载...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 获取文件名
                        const fileName = filePath.split('/').pop();
                        
                        // 获取文件
                        const response = await fetch(filePath);
                        const blob = await response.blob();
                        
                        // 创建下载链接
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        
                        // 清理
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(link);
                        loading.close();
                    } catch (error) {
                        console.error('下载文件失败:', error);
                        this.$message.error('下载文件失败，请稍后重试');
                    }
                } else {
                    this.$message.info(`下载${fileType}文件失败，文件不存在`);
                }
            },
            // 添加视频播放相关方法
            playVideo(url, title) {
                this.currentVideoUrl = url;
                this.videoTitle = title;
                this.videoDialogVisible = true;
                // 等待 DOM 更新后播放视频
                this.$nextTick(() => {
                    if (this.$refs.videoPlayer) {
                        this.$refs.videoPlayer.play();
                    }
                });
            },
            closeVideoDialog() {
                if (this.$refs.videoPlayer) {
                    this.$refs.videoPlayer.pause();
                    this.$refs.videoPlayer.currentTime = 0;
                }
                this.currentVideoUrl = '';
                this.videoTitle = '';
            },
            // 添加检测移动设备方法
            checkIsMobile() {
                this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
        },
    }
</script>
<style scoped>
    .Order {
        width: 100%;
        min-width: 910px;
    }

    .table-container {
        width: 100%;
        overflow-x: auto;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        padding-bottom: 8px;
    }

    .table-container::-webkit-scrollbar {
        height: 8px;
        background-color: #f5f5f5;
    }

    .table-container::-webkit-scrollbar-thumb {
        background: #909399;
        border-radius: 4px;
    }

    .table-container::-webkit-scrollbar-thumb:hover {
        background: #606266;
    }

    .table-container::-webkit-scrollbar-track {
        background: #e4e7ed;
        border-radius: 4px;
    }

    .no-wrap-table {
        width: max-content !important;
        min-width: 100%;
    }

    ::v-deep .el-table th {
        text-align: center;
        white-space: nowrap !important;
        color: #303030;
        font-weight: bold;
        background-color: #f5f5f5;
    }

    ::v-deep .el-table td {
        text-align: center;
        white-space: nowrap !important;
    }

    ::v-deep .el-table .cell {
        white-space: nowrap !important;
        line-height: 23px;
    }

    .custom-text-size {
        font-size: 14px !important;
        text-align: center;
    }

    .PageDis {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        background: #fff;
        margin-top: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }

    .operation-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    .operation-buttons .el-button {
        margin-right: 10px;
    }

    .operation-buttons .el-button:last-child {
        margin-right: 0;
    }

    .ColorBlue {
        color: #58C1B6 !important;
        border-color: #58C1B6 !important;
    }
    
    .ColorBlue:hover {
        color: #fff !important;
        background-color: #58C1B6 !important;
        border-color: #58C1B6 !important;
    }

    ::v-deep .ellipsis-cell {
        max-width: 150px;
    }

    ::v-deep .ellipsis-cell .cell {
        width: 100%;
        padding: 0 8px;
    }

    .ellipsis-content {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }

    ::v-deep .el-tooltip__popper {
        max-width: 50%;
        line-height: 1.5;
        padding: 8px 12px;
        font-size: 14px;
    }

    ::v-deep .el-table td:not(.ellipsis-cell) .cell {
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: unset !important;
    }

    .detail-content {
        padding: 20px;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        border-left: 4px solid #409EFF;
        padding-left: 10px;
        margin-bottom: 20px;
    }

    .section-divider {
        height: 1px;
        background-color: #EBEEF5;
        margin: 20px 0;
    }

    .detail-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        margin-bottom: 20px;
    }

    .detail-item {
        display: flex;
        align-items: flex-start;
    }

    .detail-item .label {
        width: 100px;
        color: #606266;
        font-weight: bold;
    }

    .detail-item .value {
        flex: 1;
        color: #333;
    }

    .file-item {
        display: flex;
        align-items: center;
    }

    .file-icon {
        width: 32px;
        height: 32px;
        margin-right: 10px;
    }

    .file-actions {
        display: flex;
        gap: 15px;
    }

    .action-btn {
        color: #58C1B6 !important;
        font-size: 14px;
    }

    .action-btn:hover {
        color: #4BA89E !important;
    }

    /* 修改视频播放相关样式 */
    .video-dialog {
        ::v-deep .el-dialog__body {
            padding: 0;
        }
    }

    .video-container {
        width: 100%;
        background: #000;
        position: relative;
        padding-top: 56.25%; /* 16:9 宽高比 */
    }

    .video-player {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
    }

    /* 移动端适配 */
    @media screen and (max-width: 768px) {
        .video-dialog {
            ::v-deep .el-dialog {
                margin: 0 !important;
                position: fixed;
                top: 0;
                left: 0;
                width: 100% !important;
                height: 100% !important;
                max-width: 100%;
                max-height: 100%;
                display: flex;
                flex-direction: column;
            }

            ::v-deep .el-dialog__header {
                padding: 10px;
                margin: 0;
                background: #fff;
                z-index: 1;
            }

            ::v-deep .el-dialog__title {
                font-size: 16px;
            }

            ::v-deep .el-dialog__headerbtn {
                top: 10px;
                right: 10px;
            }

            ::v-deep .el-dialog__body {
                flex: 1;
                overflow: hidden;
                padding: 0;
                margin: 0;
            }

            .video-container {
                height: 100%;
                padding-top: 0;
            }

            .video-player {
                position: relative;
                height: 100%;
            }
        }
    }
</style>